import { $post, $get, dealError } from "@/utils"
import { cookie } from "@/utils/tools.js"
import { Api } from '@tt/api'
const user = {
  state: {
    loginInfo: {},
    moneyObj: {},
    f5lodiing: false,
    userInfo: {}
  },
  mutations: {
    SET_LOGIN_INFO: (state, loginInfo) => {
      state.loginInfo = loginInfo
    },
    SET_MONEY_INFO: (state, moneyObj) => {
      state.moneyObj = moneyObj
    },
    SET_f5LODIING: (state, f5lodiing) => {
      state.f5lodiing = f5lodiing
    },
    USERINFO: (state, data) => {
      state.userInfo = data
    }
  },
  getters: {
    userInfo(state) {
      return state.userInfo;
    }
  },
  actions: {
    login({ commit }, res) {
      commit('SET_LOGIN_INFO', res.loginInfo)
    },
    moneyInfo({ commit }, res) {
      commit('SET_MONEY_INFO', res.moneyObj)
    },
    pageLodiing({ commit }, res) {
      commit('SET_f5LODIING', res.f5lodiing)
    },
    getuserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        Api.getUserInfo((res) => {
          commit('USERINFO', res)
        }, (err) => { });
      })
    },
    loginOut({ commit }) {
      commit('USERINFO', {})
      cookie.remove('userInfo');
      cookie.clear();
    }
  },
}
export default user
